module.exports = __webpack_public_path__ + "static/media/img-2.141547b8.png";